import ProgressionModalCompletedSession from './progression-modal-completed-session';
import ProgressionModalPausedSession from './progression-modal-paused-session';
import { PauseExerciseSessionResponse, StopExerciseSessionResponse } from '../../api/exercises-api';

interface ExerciseProgressionModalsProps {
  pausedSession?: PauseExerciseSessionResponse;
  finishedSession?: StopExerciseSessionResponse;
  onResume: () => void;
  onRestart?: () => void;
  onReview: (sessionId: string) => void;
}

function ExerciseProgressionModals({
  pausedSession,
  finishedSession,
  onResume,
  onRestart,
  onReview,
}: ExerciseProgressionModalsProps) {
  if (pausedSession) {
    return (
      <ProgressionModalPausedSession
        result={pausedSession.result}
        onResume={onResume}
        onRestart={pausedSession.notRestartable ? undefined : onRestart}
      />
    );
  }

  if (finishedSession) {
    return (
      <ProgressionModalCompletedSession
        result={finishedSession.result}
        onReview={onReview}
        onRestart={finishedSession.notRestartable ? undefined : onRestart}
      />
    );
  }

  return null;
}

export default ExerciseProgressionModals;
